import { EntryFields } from 'contentful';
import { TypeKeyValueListFields } from '@/core/generated-types';

export type Translations = {
  [key: string]: string;
};

export default function generateTranslationsObject(
  translations?: TypeKeyValueListFields,
) {
  if (!translations) {
    console.warn(
      '[generateTranslationsObject] no translations provided, unable to generate translations object.',
    );

    // return an empty object to prevent propagating runtime errors from accessing an attribute from an undefined object
    return {};
  }

  const formattedTranslations: Translations = {};

  translations.keyValues?.forEach((translation: EntryFields.Object) => {
    const { key, value } = translation;
    formattedTranslations[key] = value;
  });

  return formattedTranslations;
}
